import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/** Sends Meta Pixel PageView + GA4 page_view on every public route change. Never on /admin*. */
export const AnalyticsRouteTracker = () => {
  const { pathname, search } = useLocation();
  const first = useRef(true);
  const last = useRef(null);
  useEffect(() => {
    if (/^\/(admin|app|login)(\/|$)/.test(pathname)) return;
    const key = pathname + search;
    if (last.current === key) return; // StrictMode double-invoke / same-route re-render guard
    last.current = key;
    const cfg = window.__analytics || {};
    const initial = first.current;
    first.current = false;
    if (cfg.pixel && window.fbq && !initial) window.fbq("track", "PageView"); // initial Pixel PageView is sent by index.html
    if (cfg.ga4 && window.gtag) window.gtag("event", "page_view", { page_path: pathname + search, page_location: window.location.href, page_title: document.title, send_to: cfg.ga4 });
  }, [pathname, search]);
  return null;
};
